import { Action } from 'redux'

import { pdpSelectors } from '@ynap/product-details-state'
import type { ResponseError } from '@ynap/api-utils'

import { Product } from 'app/types/common-types'
import {
    FETCH_PRODUCT_DETAILS_REQUEST,
    FETCH_PRODUCT_DETAILS_SUCCESS,
    FETCH_PRODUCT_DETAILS_ERROR,
    UPDATE_LINE_ITEM_ERROR,
    SET_SELECTED_VARIANT,
} from '../constants/ActionTypes'
import type GenericAction from './types/genericAction.types'

type State = {
    loading?: boolean
    error?: ResponseError | null
    product?: Product | null
    partNumber?: string | null
}

type ActionPayload =
    | { payload: Product; partNumber: never; error: never }
    | { partNumber: string; payload: never; error: never }
    | { error: ResponseError; payload: never; partNumber: never }

type CartProductDetailsType = GenericAction<
    | typeof FETCH_PRODUCT_DETAILS_REQUEST
    | typeof FETCH_PRODUCT_DETAILS_SUCCESS
    | typeof FETCH_PRODUCT_DETAILS_ERROR
    | typeof UPDATE_LINE_ITEM_ERROR
    | typeof SET_SELECTED_VARIANT,
    ActionPayload
>

const { setSelectedWithinProduct } = pdpSelectors

const defaultState = {
    loading: true,
    error: null,
    product: null,
    partNumber: null,
}

// TODO: can leave here and use selector in reducer, or move logic into getProductDetails reducer like PDP
// This is used to set productColour partNumber and skuLevel partNumber which means you can use the same action, however logic to find productColour is over complicated. Can even use the same action but change the payload
const setSelectedVariant = (state: State, { payload }) => {
    return {
        ...state,
        product: setSelectedWithinProduct(state.product, payload),
    }
}

const fetchProductDetailsRequest = (state: State, { partNumber }: { partNumber: string }) => ({ ...state, error: null, loading: true, partNumber })

const fetchProductDetailsSuccess = (state: State, { payload }: { payload: Product }) => {
    return {
        ...state,
        loading: false,
        product: payload,
    }
}

const fetchProductDetailsError = (state: State, { error }: { error: ResponseError }) => ({ ...state, error: error.message, loading: false })

const updateLineItemError = (state: State, { error }: { error: ResponseError }) => ({ ...state, error: error.message })

export default function cartProductDetails(state: State = defaultState, action: CartProductDetailsType) {
    switch (action.type) {
        case FETCH_PRODUCT_DETAILS_REQUEST:
            return fetchProductDetailsRequest(state, action)
        case FETCH_PRODUCT_DETAILS_SUCCESS:
            return fetchProductDetailsSuccess(state, action)
        case FETCH_PRODUCT_DETAILS_ERROR:
            return fetchProductDetailsError(state, action)
        case UPDATE_LINE_ITEM_ERROR:
            return updateLineItemError(state, action)
        case SET_SELECTED_VARIANT:
            return setSelectedVariant(state, action)
        default:
            return state
    }
}
